export default "__VITE_ASSET__9be129c7__"